import { Container } from "../components/ui/Container";

export function Footer({ name, showYear }: { name: string; showYear?: boolean }) {
  return (
    <footer className="bx-border bx-section-muted border-t py-10 text-center text-sm">
      <Container>
        <p className="bx-text-muted">
          {name}
          {showYear ? ` · ${new Date().getFullYear()}` : ""}
        </p>
        <p className="bx-text-subtle mt-2">IT Application Support · Oracle PL/SQL · Lisbon, Portugal</p>
      </Container>
    </footer>
  );
}
